<template>
    <div class="pa-4">
        <v-card
            @drop.prevent="onDrop($event)"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false"
            flat
            tile
            height="192"
            class="custom-border"
        >
            <div class="pa-6">
                <div class="d-flex align-center pb-8">
                    <v-icon color="#363E59" x-large>attach_file</v-icon>
                    <div>
                        <div class="text-subtitle-2 font-weight-bold">Перетащите сюда файлы <span style="color: #DA0B0B">*</span></div>
                        <div class="text-subtitle-2 d-inline-block mr-4">JPG, JPEG, PDF, не более 28 Мб, или нажмите</div>
                        <v-btn class="black--text font-weight-bold" @click="openFileInput" height="32" width="95">обзор</v-btn>
                        <input ref="fileInput" type="file" style="display: none" @change="handleFileInputChange" multiple />
                    </div>
                </div>
                <div style="gap: 8px" class="d-flex" v-if="uploadedFilesSync.length > 0">
                    <div v-for="(file, index) in uploadedFilesSync" :key="index">
                        <v-img
                            @click="file.isDeletable && removeImg(file)"
                            relative
                            :src="file.preview === 'pdf' ? pdfImage : file.preview"
                            alt="File Preview"
                            width="48"
                            height="48"
                        >
                            <v-img v-if="file.isDeletable" class="pointer w-100" absolute src="../../assets/cancelIcon.svg" />
                        </v-img>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: 'UploadDocuments',
    props: ['uploadedFiles'],
    data: function() {
        return {
            dragover: false,
            pdfImage: require(`../../assets/pdfImage.png`)
        };
    },
    computed: {
        uploadedFilesSync: {
            get() {
                return this.uploadedFiles;
            },
            set(val) {
                this.$emit('update:uploadedFiles', val);
            }
        }
    },
    methods: {
        ...mapActions('base', ['showMessage']),
        onDrop(e) {
            this.dragover = false;
            this.handleFiles(e.dataTransfer.files);
        },
        openFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileInputChange(e) {
            this.handleFiles(e.target.files);
        },
        handleFiles(files) {
            const allowedTypes = [
                'image/jpeg',
                'image/jpg',
                'application/pdf',
                'application/x-pdf',
                'application/acrobat',
                'applications/vnd.pdf',
                'text/pdf',
                'text/x-pdf'
            ];

            if (files.length > 0) {
                if (this.uploadedFilesSync.length >= 3) {
                    this.showMessage({
                        message: 'Нельзя загружать более трех файлов',
                        color: 'error'
                    });
                    return;
                }
                Array.from(files).forEach(file => {
                    if (!allowedTypes.includes(file.type)) {
                        this.showMessage({ message: 'JPG, JPEG, PDF', color: 'error' });
                        return;
                    }
                    if (file.size >= 28 * 1024 * 1024) {
                        this.showMessage({
                            message: 'Загрузите файл не более 28 Мб',
                            color: 'error'
                        });
                        return;
                    }
                    const reader = new FileReader();
                    reader.onload = () => {
                        let preview;
                        if (reader.result.startsWith('data:application/')) {
                            preview = 'pdf';
                        } else {
                            preview = reader.result;
                        }
                        this.uploadedFilesSync.push({
                            file,
                            preview,
                            isDeletable: true
                        });
                    };
                    reader.readAsDataURL(file);
                });
            }
        },
        removeImg(file) {
            this.uploadedFilesSync = this.uploadedFilesSync.filter(uploadedFile => uploadedFile !== file);
        }
    }
};
</script>

<style scoped>
.custom-border {
    border: 2px dashed #363e59;
    background-color: #ebefff;
    box-shadow: 0 4px 8px 0 #f6f7fa;
    width: 100%;
}
</style>
